import * as React from "react";
import Button from "@mui/material/Button";
import { CircularProgress } from "@mui/material";

import AlertDialog from "../../../../../components/AlertDialog/index.es6";

export default function DeletePremium(props) {

  if (!props.premium) {
    return ""
  }

  const [showWarning, setShowWarning ] = React.useState(false);


  const deletePremium = ()=>{
    setShowWarning(true) 
    props.deletePremium(props.premium)
  }

  const cancel = ()=>{
    props.resetPremiumToDelete()
  }


  const handlePremiumDeletedSuccessfully = () => {
    props.resetDeletePremiumSuccessAlert()
    props.resetPremiumToDelete()
  }

  const handlePremiumDeleteError = () => {
    props.resetDeletePremiumErrorAlert()
  }

  return (
    <React.Fragment>
      <AlertDialog
        custom
        show={props.showDeletePremiumProgressAlert}
        size="sm"
        style={{ marginTop: '0', top: '30vh' }}
        confirmBtnText={'ok'}
        showCancel={false}
        showConfirm={false}
        cancelBtnText={'cancel'}
        showTitle={false}
        confirmBtnCssClass
      >
        <CircularProgress />
        <h2>Deleting premium</h2>
      </AlertDialog>


      <AlertDialog
        warning
        show={!showWarning && props.premium}
        size="sm"
        title={'Are you sure you want to delete'}
        style={{ marginTop: '0', top: '30vh' }}
        onConfirm={() => {cancel() }}
        onCancel={() => {deletePremium()}}
        confirmBtnText={'Cancel'}
        showCancel={true}
        showConfirm={true}
        cancelBtnText={'Delete'}
        confirmBtnCssClass
      >
      </AlertDialog>

      <AlertDialog
        success
        show={props.showDeletePremiumSuccessAlert}
        size="sm"
        title={'Premium deleted'}
        style={{ marginTop: '0', top: '30vh' }}
        onConfirm={() => { handlePremiumDeletedSuccessfully() }}
        confirmBtnText={'Ok'}
        showCancel={false}
        showConfirm={false}
        cancelBtnText={'Delete'}
        confirmBtnCssClass
      >
        <div >
          <Button variant="contained" onClick={() => { handlePremiumDeletedSuccessfully() }} style={{ background: 'green', }}>Ok</Button>
        </div>
      </AlertDialog>

      <AlertDialog
        show={props.showDeletePremiumErrorAlert}
        danger
        title={'Error deleting premium'}
        onConfirm={() => handlePremiumDeleteError()}
        confirmBtnText={'Try again'}
        confirmBtnCssClass
        showCancel={false}
        style={{ marginTop: '0', top: '30vh' }}
      >
        {props.editPremiumError ? props.editPremiumError.message : ''}
      </AlertDialog>






    </React.Fragment>

  );



}
